import { createTriggerFindTargetReportContext } from '@/context/InvoiceReports';
import { InvoiceReportColumn } from '@/features/invoice_reports/types';

export const {
  Provider: TriggerFindTargetReportProvider,
  useTriggerFindTargetReport,
} = createTriggerFindTargetReportContext<InvoiceReportColumn>();
